var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgS(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    style: {
      fill: "#808183"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.104 54.18c.304 2.191.9 3.83 1.79 4.915 1.628 1.975 4.417 2.962 8.366 2.962 2.366 0 4.286-.26 5.762-.781 2.8-.998 4.2-2.854 4.2-5.566 0-1.585-.695-2.81-2.084-3.679-1.389-.846-3.57-1.595-6.543-2.246l-5.078-1.14c-4.991-1.128-8.442-2.354-10.352-3.678-3.233-2.213-4.85-5.675-4.85-10.384 0-4.296 1.563-7.866 4.688-10.71 3.125-2.842 7.714-4.264 13.77-4.264 5.056 0 9.369 1.34 12.939 4.02 3.57 2.68 5.441 6.57 5.615 11.67H53.69c-.173-2.886-1.432-4.937-3.776-6.152-1.562-.803-3.504-1.204-5.826-1.204-2.583 0-4.645.52-6.185 1.562-1.541 1.042-2.312 2.496-2.312 4.362 0 1.715.76 2.995 2.28 3.841.976.565 3.059 1.227 6.25 1.986l8.267 1.986c3.624.868 6.359 2.029 8.203 3.483 2.865 2.257 4.297 5.523 4.297 9.798 0 4.384-1.676 8.024-5.029 10.921-3.353 2.897-8.09 4.346-14.209 4.346-6.25 0-11.165-1.427-14.746-4.28-3.58-2.854-5.371-6.777-5.371-11.768h9.57Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgS);
export default __webpack_public_path__ + "static/media/s.93f49e703476213345d17fbd20d10cff.svg";
export { ForwardRef as ReactComponent };